import '@nettbureau/theme';
import 'radash';
import 'polished';
import { parseTextShadow } from '../parsers/text-shadow.js';

/**
 * Generates CSS for applying a subtle text shadow to a text element to
 * improve readability.
 *
 * @param theme - The theme object.
 */ function textShadow(shadow) {
    return (theme)=>({
            textShadow: parseTextShadow(theme, shadow)
        });
}

export { textShadow };
//# sourceMappingURL=text-shadow.js.map
